import Axios from 'axios';
import { getEnvVar } from '../../utilities/getEnvs.js';

var util = {
  refreshAuthToken: function refreshAuthToken(instance) {
    return Axios.post("".concat(instance, "/auth/token"), undefined, {
      withCredentials: true,
      headers: {
        APPLICATION_ID: getEnvVar('APPLICATION_ID')
      }
    });
  },
  login: function login(instance) {
    return Axios.post("".concat(instance, "/auth/login"), undefined, {
      withCredentials: true,
      headers: {
        APPLICATION_ID: getEnvVar('APPLICATION_ID')
      }
    });
  }
};

export { util as default };
